module.exports = __webpack_public_path__ + "img/facebook.9ac88a58.webp";